/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { styled } from "@mui/material/styles";
import { Card, CircularProgress, Tooltip, tooltipClasses } from "@mui/material";
import { useDispatch } from "react-redux";
import profileIcon from "assets/images/Profile-1.svg";
import profileIconDark from "assets/images/Profile.svg";
import MDBadge from "components/MDBadge";
import { useMaterialUIController } from "context";
import moment from "moment/moment";
import { SupportUserTickets } from "api-services";
import PropTypes from "prop-types";
const Author = ({ name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDBox lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    fontFamily: "inherit",
    textAlign: "left",
  },
});

function SupportRM() {
  useEffect(() => {
    SupportUserTickets(dispatchData, successAction, errorAction);
  }, []);

  const [rows, setRows] = useState([]);

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [dataLoading, setDataLoading] = useState(true);

  const dispatchData = useDispatch();

  const columns = [
    { Header: "Support ID", accessor: "id", align: "left" },
    { Header: "full Name", accessor: "full_name", align: "left" },
    { Header: "subject", accessor: "subject", align: "left" },
    { Header: "message", accessor: "message", width: "40%", align: "left" },
    { Header: "posted On", accessor: "posted_on", align: "left" },
    { Header: "status", accessor: "status", align: "left" },
  ];

  const successAction = (res) => {
    setDataLoading(false);
    let allSupportItem = res.data.map((item) => {
      console.log(item);
      return {
        id: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item.id}
          </MDTypography>
        ),
        full_name: (
          <Author
            image={darkMode ? profileIcon : profileIconDark}
            name={item.fullName}
            email={item.email}
          />
        ),
        subject: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item.subject}
          </MDTypography>
        ),
        message: (
          <CustomWidthTooltip title={item.message} arrow>
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="medium"
              className="max-length"
            >
              {item.message}
            </MDTypography>
          </CustomWidthTooltip>
        ),

        posted_on: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {" "}
            {moment(item.postedOn).format("MM/DD/yyyy")}
          </MDTypography>
        ),
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={item.status}
              color={item.status == "Unresolved" ? "error" : "success"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
      };
    });

    setRows(allSupportItem);
    // console.log(res.data);
  };

  const errorAction = () => {
    setDataLoading(false);
  };

  return (
    <MDBox mb={3} mt={4}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox pt={3} pb={3} display="flex" justifyContent="center">
              {dataLoading ? (
                <CircularProgress color="success" size={30} />
              ) : (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  canSearch={true}
                  noEndBorder
                  setGlobalFilterAPI={(value) => {
                    SupportUserTickets(
                      dispatchData,
                      successAction,
                      errorAction,
                      value
                    );
                  }}
                />
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}
Author.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};
export default SupportRM;
